export default "__VITE_ASSET__cDSU2wQf__"